// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        gap: 10,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
                align-items: baseline;
            }
        `,
        css: css`
            padding: 10px 15px;
        `,
    }),
};

savedOrderListFilterStyles.headingGridItem = {
    css: css`
        display: none;
    `,
};

savedOrderListFilterStyles.orderTotalGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.orderTotalGridItem, {
        css: css`
            &&&& {
                align-items: baseline;
            }
        `,
    }),
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = savedOrderListFilterStyles.orderTotalAmountGridItem = {
    ...myAccountFilterSectionStyles.mediumGridItem,
};

savedOrderListFilterStyles.datesGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.datesGridItem, {
        css: css`
            &&&& {
                align-items: baseline;
            }
        `,
    }),
};

savedOrderListFilterStyles.toGridItem = savedOrderListFilterStyles.fromGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.mediumGridItem, {
        css: css`
            &&&& {
                align-items: baseline;
            }
        `,
    }),
};

savedOrderListFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

savedOrderListFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
savedOrderListFilterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        &&& {
            padding-right: 10px;
        }
    `,
};
